import Styles from './styles.module.css';
import SectionTitle from '../../home/_ui/sectionTitle';

const STEPS = [
  { no: '01', title: '現在の求人票管理をヒアリング', text: '紙・PDF・Drive など、いまの受け取り方と整理方法をお聞きします。' },
  { no: '02', title: '学校用の環境を準備', text: 'memorii works 側で学校用の管理画面をご用意します。' },
  { no: '03', title: 'サロンへの利用案内', text: 'memorii works からサロンへ Web での求人票提出をご案内します。' },
  { no: '04', title: '運用開始', text: '届いた求人票を管理画面で確認し、学生へ公開していきます。' },
];

const Steps = () => {
  return (
    <section id="steps" className={Styles.steps}>
      <SectionTitle
        pattern="B"
        title="導入までの流れ"
        lead="学校側で、過去の求人票をすべて手入力し直す必要はありません。"
      />

      <ol className={Styles.list}>
        {STEPS.map((s) => (
          <li key={s.no} className={Styles.item}>
            <span className={Styles.no}>{s.no}</span>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default Steps;
